import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { CloudODSComponent } from './cloud.component';
import { TablaComponent } from './tabla/tabla.component';

import { ExtensionPipe } from './tabla/tabla.pipe';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { BytesPipe } from './tabla/bytes.pipe';
import { DropFileDirective } from './drop-file.directive';

@NgModule({
  declarations: [
    CloudODSComponent,
    TablaComponent,
    ExtensionPipe,
    BytesPipe,
    DropFileDirective
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatMenuModule,
    MatProgressSpinnerModule
  ]
})
export class CloudODSModule { }
